module.exports = __webpack_public_path__ + "img/badge-most-created-leads-keyvue-green.609fedcb.png";